import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { proyecto } from '../models/proyecto';
import {CookieService} from "ng2-cookies";
import {Navigation} from "./navigation.service";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class ProyectoService {

  private selectALocation: boolean = false;
  private proyectoActual: proyecto;
  private showProyecto: boolean = false;
  private lastPage: string = "";

  constructor(private http: HttpClientService, private cookieService: CookieService,
              private navigation: Navigation) { }

  getAll() {
    return this.http.get('/proyecto/getall');
  }

  public new(proyecto: proyecto) {
    return this.http.post('/proyecto/new', proyecto);
  }

  public setProyectoActual(proyecto: proyecto) {
    if (proyecto != undefined) {
      this.selectALocation = false;
      this.proyectoActual = proyecto;
      
      if(!this.cookieService.check("project") || this.cookieService.get("project") !== proyecto.idProyecto) {
        this.cookieService.set("project", proyecto.idProyecto);
        this.updateIdProyectoSeleccionado(proyecto.idProyecto);
      }
      
    }
  }

  private updateIdProyectoSeleccionado(idProyecto: string) {
    if (!idProyecto) {
      return;
    }

    let json = {
      "idProyecto": idProyecto
    };

    this.http.patch('/user/change-id-proyecto-seleccionado', JSON.stringify(json)).subscribe(
      result => {
      },
      error => {
      }
    );
  }

  public proyectoActualCookie() {
    if (this.cookieService.check("project")) {
      return this.cookieService.get("project") != "";
    } else {
      return false;
    }
  }

  public getProyectoActual() {
    return this.proyectoActual;
  }

  public setShowProyecto(bool: boolean) {
    this.showProyecto = bool;
  }

  public showProyectoFunc() {
    return this.showProyecto;
  }

  public setTrueSelectALocation(page: string) {
    this.selectALocation = true;
    this.lastPage = page;
  }

  public getLastPage() {
    return this.lastPage;
  }

  public setLastPage(page: string) {
    this.lastPage = page;
  }

  toLastPage() {
    console.log(this.lastPage)
    if(this.lastPage == "") {
      this.navigation.toIndicators();
    } else if(this.lastPage == "indicators") { //////////////
      this.navigation.toIndicators();
    } else if(this.lastPage == "floorplans") { //////////////
      this.navigation.toSelectFloorplan();
    } else if(this.lastPage == "zones") { //////////////
      this.navigation.toAteneoZones();
    } else if(this.lastPage == "alerts") { //////////////
      this.navigation.toAlerts();
    } else if(this.lastPage == "fade") { //////////////
      this.navigation.toFade();
    } else if(this.lastPage == "limits") { //////////////
      this.navigation.toLimits();
    } else if(this.lastPage == "rules") { //////////////
      this.navigation.toReglas();
    } else if(this.lastPage == "parameters") { //////////////
      this.navigation.toParameters();
    }

    /* NOT IN USE
    } else if(this.lastPage == "rules") { //////////////
      this.navigation.toReglas();
    }
    } else if(this.lastPage == "warnings") { //////////////
      this.navigation.toWarnings();
    }
     */
    else if(this.lastPage == "ota") { //////////////
      this.navigation.toOta();
    }
    this.lastPage = "";
  }

  public getSelectALocation() {
    return this.selectALocation;
  }

  public getSimpleInfo(idProyecto) {
    let params = new HttpParams().set("idProyecto", idProyecto);
    return this.http.getWithParams('/proyecto/getsimpleinfo', params);
  }

  public getSimpleInfoList(listaIdProyectos: string[]) {
    const joinedIds = listaIdProyectos.join(",");
    let params = new HttpParams().set("listaIdProyectos", joinedIds);
    return this.http.getWithParams('/proyecto/getsimpleinfolist', params);
  }

  public delete(id: string) {
    return this.http.delete('/proyecto/delete/' + id);
  }

}
